import { useEffect } from 'react';

type Props = {
  msg: string;
  kind?: 'ok' | 'err';
  onDone?: () => void;
};

export function Toast({ msg, kind = 'ok', onDone }: Props) {
  useEffect(() => {
    if (!onDone) return;
    const t = window.setTimeout(onDone, 3200);
    return () => window.clearTimeout(t);
  }, [msg, onDone]);
  return <div className={`toast ${kind}`}>{msg}</div>;
}
